import { lazy } from 'react';

export const LazyUserPostSignUpPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--user-post-sign-up-page" */ './user-post-sign-up-page'
    ),
);
